import React, { createContext, useCallback, useMemo, useState } from 'react'
import UserApi, { UserMe } from '../api/UserApi'
import useAuth from '../hooks/useAuth'
import { useInterval } from '../hooks/useInterval'

const userApi = new UserApi()

export const UserMeContext = createContext<{ updateMe: typeof userApi.updateMe; user: UserMe | null }>({
    updateMe: (data) => userApi.updateMe(data),
    user: null,
})

export const UserMeProvider = ({ children }: { children: React.ReactNode }) => {
    const [user, setUser] = useState<UserMe | null>(null)
    const { isAuthenticated } = useAuth()

    const fetcher = useCallback(async () => {
        const result = await userApi.getMe()

        setUser(result)
    }, [])

    useInterval(fetcher, 60 * 10 * 1000, isAuthenticated)

    const updateMe: typeof userApi.updateMe = useCallback(async (data) => {
        const result = await userApi.updateMe(data)

        setUser(result)

        return result
    }, [])

    const value: { user: typeof user; updateMe: typeof userApi.updateMe } = useMemo(
        () => ({
            updateMe,
            user,
        }),
        [updateMe, user],
    )

    return <UserMeContext.Provider value={value}>{children}</UserMeContext.Provider>
}
